import TokenManager from '@/middlewares/auth/TokenManager';

export interface TokensI {
  access_token: string;
  expires_in: number;
  refresh_token: string;
  token_type: 'Bearer';
}

const saveTokens = (tokens: TokensI): void => {
  const tokenManager = TokenManager.getInstance();
  tokenManager.setAccessToken(tokens.access_token);
};

const removeTokens = (): void => {
  const tokenManager = TokenManager.getInstance();
  tokenManager.setAccessToken('');
};

const restoreTokens = (): Record<keyof Pick<TokensI, 'refresh_token'>, Nullable<string>> => {
  return { refresh_token: null };
};

export { saveTokens, removeTokens, restoreTokens };
